<!-- <div class="drawer_nav">
    <div>
        <mat-icon [style.color]="color" [(colorPicker)]="color">palette</mat-icon>
        <input [style.background]="color" [(colorPicker)]="color" (colorPickerChange)="changeColor()"/>
    </div>
</div> -->

<svg #svg id="drawer_svg"></svg>
